import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAtom } from 'jotai';
import { selectedBerthAtom } from '@/atoms/berthAtoms';
import { useReturnToMapParams } from '@/features/SafetyPrediction/BerthDashboard/hooks/useReturnToMapParams';

export function useBackToMapFromOperationalCallback() {
  return useSafetyPredictionCallback(SafetyPredictionPath.Operational);
}

export function useBackToMapFromSimulationCallback() {
  return useSafetyPredictionCallback(SafetyPredictionPath.Simulation);
}

enum SafetyPredictionPath {
  Operational = '/safety-prediction/operational',
  Simulation = '/safety-prediction/simulation',
}

function useSafetyPredictionCallback(path: SafetyPredictionPath) {
  const navigate = useNavigate();
  const [selectedBerth] = useAtom(selectedBerthAtom);
  const [searchParams] = useSearchParams();
  const returnToMapQueryParams = useReturnToMapParams({
    lat: selectedBerth?.location?.latitude,
    lng: selectedBerth?.location?.longitude,
  });
  const isOperationalDetailView = !!searchParams.get('mmsi');
  // Determines if we are in the detail view to decide whether to include map parameters when navigating back.
  // For operational callback: add params only if in operational detail view.
  // For simulation callback: add params only if in simulation detail view.
  let url: string;
  if (path === SafetyPredictionPath.Operational) {
    url = isOperationalDetailView ? `${path}?${returnToMapQueryParams}` : path;
  } else {
    url = isOperationalDetailView ? path : `${path}?${returnToMapQueryParams}`;
  }

  return useCallback(() => navigate(url), [navigate, url]);
}
